import { MeshGradient } from '../shaders/MeshGradient/MeshGradient'
import styles from './styles.module.scss'

interface Props {
    title?: string
    description?: string
    href?: string
    /** Overrides the mesh gradient palette, so each dashboard can have its own colours. */
    colors?: readonly string[]
}

export const ExternalDashboardCard = ({
    title = 'Sentinel CMS',
    description = 'Manage the Sentinel Legal website content and introducer form content',
    href,
    colors,
}: Props) => {
    const content = (
        <>
            <MeshGradient colors={colors} />
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <span className={styles.title}>{title}</span>
                </div>
                <p className={styles.description}>{description}</p>
                <div className={styles.actions}>
                    <span className={styles.ctaPill}>Go to site</span>
                </div>
            </div>
        </>
    )

    if (href) {
        return (
            <a className={styles.card} href={href} target="_blank" rel="noopener noreferrer">
                {content}
            </a>
        )
    }

    return <div className={styles.card}>{content}</div>
}

export default ExternalDashboardCard
